var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.857 14c0-.69-.56-1.25-1.25-1.25l-7.064-.414c-.845-.05-1.267-.074-1.536-.343-.269-.269-.294-.691-.343-1.536l-.414-7.064a1.25 1.25 0 1 0-2.5 0l-.414 7.064c-.05.845-.074 1.267-.343 1.536-.269.269-.691.294-1.536.343l-7.064.414a1.25 1.25 0 1 0 0 2.5l7.064.414c.845.05 1.267.074 1.536.343.269.269.294.691.343 1.536l.414 7.064a1.25 1.25 0 1 0 2.5 0l.414-7.064c.05-.845.074-1.267.343-1.536.269-.269.691-.294 1.536-.343l7.064-.414c.69 0 1.25-.56 1.25-1.25Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus28);
export default __webpack_public_path__ + "static/media/plus_28.8607339f.svg";
export { ForwardRef as ReactComponent };